/* Intake-page translations — kept inline (not in /locales/*.json) because the
   intake is a single page with a lot of UX-specific copy that would clutter
   the main locale files. Falls back to Spanish for unknown languages. */

const NL = {
  // Header / progress
  badge: "Summer Sale · 6 vragen · 100% gratis",
  hero_t: "Vertel ons over\nje woning.",
  hero_p: "Hoe meer we weten, hoe persoonlijker je rapport. Geen verkooppraatjes — je antwoorden gebruiken we alleen om jouw dossier te maken.",
  q: "Vraag", of_: "van", section_label: "Sectie", almost: "Bijna klaar",
  vraag_total: "Vraag {n} van {total}",
  nav_close_title: "Afsluiten",

  // Section titles + subs + "why"
  s1_t: "Begin met je elektriciteitsfactuur", s1_s: "Eén bestand. Wij doen de rest.",
  s1_w: "Hieruit leest onze AI automatisch je jaarverbruik, je tarief en je adres.",
  s2_t: "Je type aansluiting", s2_s: "Eén klik bevestiging — kies je antwoord.",
  s2_w: "Bepaalt of we een 1-fase of 3-fase omvormer & batterij voor je woning kiezen.",
  s3_t: "Over je woning", s3_s: "Bouwjaar, oppervlakte, bewoners.",
  s3_w: "Bouwjaar en oppervlakte beïnvloeden subsidies en de optimale systeemkeuze.",
  s4_t: "Toekomstige apparatuur", s4_s: "Wat ga je nog aanschaffen?",
  s4_w: "Apparaten die je nu al hebt zitten in je elektriciteitsfactuur — daar rekenen we al mee. Hier gaat het om wat je nog gaat toevoegen.",
  s5_t: "Je dak", s5_s: "Teken je dakvlak op de satellietfoto.",
  s5_w: "Oppervlakte, oriëntatie en hellingshoek bepalen je opbrengst — soms ±30% verschil.",
  s6_t: "Belastingsituatie", s6_s: "Bepaalt jouw subsidies.",
  s6_w: "Spaanse residenten krijgen tot 60% IRPF-aftrek. Dat verandert de ROI sterk.",

  // Bill upload
  drag: "Sleep je elektriciteitsfactuur hierheen", or_click: "Of klik om te kiezen",
  file_too_big: "Bestand te groot (max 10MB)",

  // Phase
  phase_mono_l: "1-fase (mono)", phase_mono_s: "De meeste woningen — tot ±9 kW aansluitvermogen",
  phase_tri_l: "3-fase (trifásico)", phase_tri_s: "Vaak villa's, ≥ 9,2 kW aansluitvermogen",
  phase_unk_l: "Weet ik niet", phase_unk_s: "Wij leiden het af uit je elektriciteitsfactuur",

  // Dwelling
  dw_year_label: "Bouwjaar",
  yb1: "Voor 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "Na 2018",
  dw_m2_label: "Oppervlakte (m²)", dw_persons_label: "Bewoners", dw_bath_label: "Badkamers",
  dw_primary_label: "Hoofdwoning?", yes: "Ja", no: "Nee",
  dw_type_label: "Woningtype",
  dwt_detached: "Vrijstaand", dwt_semi: "Twee-onder-een-kap", dwt_terrace: "Rijwoning",
  dwt_apt: "Appartement", dwt_villa: "Villa",

  // Usage
  usage_q: "Welke van onderstaande apparaten **ga je nog aanschaffen** in de komende jaren?",
  usage_hint: "Apparaten die je nu al hebt zitten in je huidige elektriciteitsfactuur — die hoef je hier niet aan te vinken.",
  u_ev: "Elektrische auto", u_hp: "Warmtepomp", u_pool: "Zwembad", u_ac: "Airconditioning", u_ind: "Inductie kookplaat",
  wp_q: "Waarvoor gebruik je je warmtepomp?",
  wp_water_l: "Tapwater (douche, kraan)", wp_water_d: "Aerotermia voor warm water",
  wp_heating_l: "Verwarming (vloer/radiator)", wp_heating_d: "Aerotermia voor je hele woning",

  // Pool
  pool_q: "Vertel ons meer over je zwembad",
  pool_vol_l: "Volume zwembad", pool_vol_aux: "≈ {m2} m² × 2 m diep",
  pool_small: "Klein (~20)", pool_std: "Standaard (~40)", pool_large: "Groot (~80)",
  pool_cover_q: "Heb je een afdekzeil?", pool_cover_yes: "Ja, afgedekt", pool_cover_no: "Nee",
  pool_cover_hint: "Afdekzeil bespaart 50-70% verwarmingsenergie.",
  pool_heat_q: "Wil je het zwembad (gaan) verwarmen?",
  pool_heat_yes: "Ja, verwarmen", pool_heat_no: "Nee, onverwarmd",
  pool_heat_hint: "Verwarmd zwembad = +3.000 à 8.000 kWh/jaar — grote impact op je systeemgrootte.",
  pool_heat_type_q: "Welk type verwarming heb je in gedachten?",
  pht_aero_l: "Warmtepomp", pht_aero_d: "Aerotermia, meest efficiënt",
  pht_solar_l: "Zonnecollectoren", pht_solar_d: "Goedkoop maar afhankelijk van weer",
  pht_unk_l: "Geen voorkeur", pht_unk_d: "Wij adviseren je in je rapport",

  // Roof
  roof_pre_title: "Klik 3+ punten op je dak",
  roof_pre_body: "Zoek je adres in de kaart, zoom in tot je je dak ziet, en klik de hoekpunten van het dakvlak dat geschikt is voor panelen.",
  roof_pitch_l: "Hellingshoek",
  roof_pitch_flat: "5° plat", roof_pitch_mid: "25°", roof_pitch_steep: "45° steil",
  roof_pitch_auto: "auto",
  roof_pitch_auto_on: "✓ Wij hebben 25° gekozen (gemiddeld dak)",
  roof_pitch_auto_off: "Weet ik niet — bepaal het automatisch",
  roof_orient_l: "Oriëntatie",
  roof_orient_hint: "Zuid = beste opbrengst in Spanje",
  roof_orient_auto_with_val: "✓ Auto: {val} (op basis van je dak)",
  roof_orient_auto_pre: "✓ Wij bepalen dit uit je polygon",
  roof_orient_auto_off: "Weet ik niet — bepaal het uit mijn dak",
  roof_ok: "Dak getekend met {n} hoekpunten — opgeslagen na verzenden.",
  orientations: { Norte: "Noord", Noreste: "Noordoost", Este: "Oost", Sureste: "Zuidoost", Sur: "Zuid", Suroeste: "Zuidwest", Oeste: "West", Noroeste: "Noordwest" },

  // Fiscal
  fis_res_q: "Ben je fiscaal resident in Spanje?",
  fis_res_yes: "Ja, ik woon in Spanje", fis_res_no: "Nee, niet-resident",
  fis_inc_q: "Wat is je bruto jaarinkomen?",
  fis_inc_hint: "We berekenen jouw IRPF-aftrek op zonnepanelen. Geen exacte schijf nodig — een schatting is voldoende.",
  ib1: "< € 20.000", ib2: "€ 20.000 – 35.000", ib3: "€ 35.000 – 60.000",
  ib4: "€ 60.000 – 120.000", ib5: "> € 120.000", ib6: "Weet ik niet",
  ih_bracket: "Schijf {pct}%", ih_unknown: "We rekenen met 24% (middenschijf)",
  fis_non_res_title: "Niet-residenten betalen 24% IRPF op Spaanse inkomsten.",
  fis_non_res_body: "Je hebt geen recht op IRPF-aftrek op zonnepanelen, maar wel op IBI-korting en EU-fondsen. Die nemen we mee in je rapport.",

  // Contact + final
  final_badge: "Klaar — laatste stap", final_t: "Waar mogen we je\ndossier sturen?",
  final_p: "We mailen het volledige rapport binnen 24 uur. Geen spam, ooit.",
  ct_name_l: "Naam", ct_name_ph: "Jan de Vries",
  ct_email_l: "E-mail", ct_email_ph: "jan@email.es",
  ct_wa_l: "WhatsApp (optioneel)", ct_wa_ph: "+34 ...",
  submit: "Verstuur mijn rapport-verzoek", submit_busy: "Verzenden…",
  summer_footer: "Summer Sale · gratis voor de eerste 100",
  footer_text: "100% onafhankelijk · Geen verkoop · Vrijblijvend",

  // Validation & toasts
  fill_required: "Vul je naam en e-mail in", err_generic: "Er ging iets mis — probeer opnieuw",
  toast_ok: "Geweldig! Je behoort tot de eerste 100 — je rapport is gratis!",
};

const EN = {
  badge: "Summer Sale · 6 questions · 100% free",
  hero_t: "Tell us about\nyour home.",
  hero_p: "The more we know, the more personal your report. No sales talk — we only use your answers to build your dossier.",
  q: "Question", of_: "of", section_label: "Section", almost: "Almost done",
  vraag_total: "Question {n} of {total}",
  nav_close_title: "Finish",
  s1_t: "Start with your electricity bill", s1_s: "One file. We'll do the rest.",
  s1_w: "Our AI extracts your annual usage, tariff and address automatically.",
  s2_t: "Your connection type", s2_s: "One-click confirmation — pick your answer.",
  s2_w: "Determines whether we pick a 1-phase or 3-phase inverter & battery.",
  s3_t: "About your home", s3_s: "Build year, size, residents.",
  s3_w: "Build year and size influence subsidies and the optimal system choice.",
  s4_t: "Future appliances", s4_s: "What will you still buy?",
  s4_w: "Appliances you already own are in your current bill — we account for those. Here it's about what you'll add.",
  s5_t: "Your roof", s5_s: "Draw your roof on the satellite image.",
  s5_w: "Area, orientation and tilt determine your yield — sometimes ±30% difference.",
  s6_t: "Tax situation", s6_s: "Determines your subsidies.",
  s6_w: "Spanish residents get up to 60% IRPF deduction. Big impact on ROI.",
  drag: "Drop your electricity bill here", or_click: "Or click to choose",
  file_too_big: "File too large (max 10MB)",
  phase_mono_l: "1-phase (mono)", phase_mono_s: "Most homes — up to ±9 kW contracted power",
  phase_tri_l: "3-phase (trifásico)", phase_tri_s: "Often villas, ≥ 9.2 kW contracted power",
  phase_unk_l: "I don't know", phase_unk_s: "We'll derive it from your bill",
  dw_year_label: "Build year",
  yb1: "Before 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "After 2018",
  dw_m2_label: "Surface (m²)", dw_persons_label: "Residents", dw_bath_label: "Bathrooms",
  dw_primary_label: "Primary residence?", yes: "Yes", no: "No",
  dw_type_label: "Housing type",
  dwt_detached: "Detached", dwt_semi: "Semi-detached", dwt_terrace: "Terraced",
  dwt_apt: "Apartment", dwt_villa: "Villa",
  usage_q: "Which of these appliances will **you still buy** in the coming years?",
  usage_hint: "Appliances you already own are in your current bill — no need to tick them here.",
  u_ev: "Electric car", u_hp: "Heat pump", u_pool: "Pool", u_ac: "Air conditioning", u_ind: "Induction cooktop",
  wp_q: "What do you use your heat pump for?",
  wp_water_l: "Hot water (shower, tap)", wp_water_d: "Aerothermal for domestic hot water",
  wp_heating_l: "Heating (floor/radiator)", wp_heating_d: "Aerothermal for your whole home",
  pool_q: "Tell us about your pool",
  pool_vol_l: "Pool volume", pool_vol_aux: "≈ {m2} m² × 2 m deep",
  pool_small: "Small (~20)", pool_std: "Standard (~40)", pool_large: "Large (~80)",
  pool_cover_q: "Do you have a cover?", pool_cover_yes: "Yes, covered", pool_cover_no: "No",
  pool_cover_hint: "A cover saves 50-70% of heating energy.",
  pool_heat_q: "Do you want to heat the pool?",
  pool_heat_yes: "Yes, heated", pool_heat_no: "No, unheated",
  pool_heat_hint: "Heated pool = +3,000 to 8,000 kWh/year — big impact on system size.",
  pool_heat_type_q: "What heating type do you have in mind?",
  pht_aero_l: "Heat pump", pht_aero_d: "Aerothermal, most efficient",
  pht_solar_l: "Solar collectors", pht_solar_d: "Cheap but weather-dependent",
  pht_unk_l: "No preference", pht_unk_d: "We'll advise you in your report",
  roof_pre_title: "Click 3+ points on your roof",
  roof_pre_body: "Search your address on the map, zoom in to see your roof, and click the corners of the roof area suitable for panels.",
  roof_pitch_l: "Tilt angle",
  roof_pitch_flat: "5° flat", roof_pitch_mid: "25°", roof_pitch_steep: "45° steep",
  roof_pitch_auto: "auto",
  roof_pitch_auto_on: "✓ We picked 25° (average roof)",
  roof_pitch_auto_off: "I don't know — auto-detect",
  roof_orient_l: "Orientation",
  roof_orient_hint: "South = best yield in Spain",
  roof_orient_auto_with_val: "✓ Auto: {val} (from your roof shape)",
  roof_orient_auto_pre: "✓ We'll detect it from your polygon",
  roof_orient_auto_off: "I don't know — detect from my roof",
  roof_ok: "Roof drawn with {n} corners — saved on submit.",
  orientations: { Norte: "North", Noreste: "Northeast", Este: "East", Sureste: "Southeast", Sur: "South", Suroeste: "Southwest", Oeste: "West", Noroeste: "Northwest" },
  fis_res_q: "Are you a tax resident in Spain?",
  fis_res_yes: "Yes, I live in Spain", fis_res_no: "No, non-resident",
  fis_inc_q: "What's your gross annual income?",
  fis_inc_hint: "We'll calculate your IRPF deduction. No exact bracket needed — an estimate is fine.",
  ib1: "< € 20,000", ib2: "€ 20,000 – 35,000", ib3: "€ 35,000 – 60,000",
  ib4: "€ 60,000 – 120,000", ib5: "> € 120,000", ib6: "I don't know",
  ih_bracket: "Bracket {pct}%", ih_unknown: "We'll use 24% (middle bracket)",
  fis_non_res_title: "Non-residents pay 24% IRPF on Spanish income.",
  fis_non_res_body: "You're not entitled to IRPF deduction on solar, but you do qualify for IBI bonus and EU funds. We include those in your report.",
  final_badge: "Done — last step", final_t: "Where should we\nsend your report?",
  final_p: "We'll email the full report within 24h. No spam, ever.",
  ct_name_l: "Name", ct_name_ph: "John Smith",
  ct_email_l: "Email", ct_email_ph: "john@email.es",
  ct_wa_l: "WhatsApp (optional)", ct_wa_ph: "+34 ...",
  submit: "Send my report request", submit_busy: "Sending…",
  summer_footer: "Summer Sale · free for the first 100",
  footer_text: "100% independent · No sales · No obligation",
  fill_required: "Please enter your name and email", err_generic: "Something went wrong — please retry",
  toast_ok: "Awesome! You're among the first 100 — your report is free!",
};

const ES = {
  badge: "Summer Sale · 6 preguntas · 100% gratis",
  hero_t: "Cuéntanos sobre\ntu vivienda.",
  hero_p: "Cuantos más datos tengamos, más personalizado será tu informe. Sin ventas — solo usamos tus respuestas para tu dossier.",
  q: "Pregunta", of_: "de", section_label: "Sección", almost: "Casi listo",
  vraag_total: "Pregunta {n} de {total}",
  nav_close_title: "Finalizar",
  s1_t: "Empieza con tu factura eléctrica", s1_s: "Un archivo. Nosotros hacemos el resto.",
  s1_w: "Nuestra IA extrae tu consumo anual, tarifa y dirección automáticamente.",
  s2_t: "Tipo de conexión", s2_s: "Confirmación con un clic.",
  s2_w: "Determina si elegimos un inversor & batería monofásico o trifásico.",
  s3_t: "Sobre tu vivienda", s3_s: "Año, superficie, habitantes.",
  s3_w: "Año y superficie influyen en las subvenciones y la mejor configuración.",
  s4_t: "Electrodomésticos futuros", s4_s: "¿Qué planeas comprar?",
  s4_w: "Lo que ya tienes está en tu factura actual — eso ya lo contamos. Aquí dinos qué añadirás.",
  s5_t: "Tu tejado", s5_s: "Dibuja tu tejado en la imagen satelital.",
  s5_w: "Superficie, orientación e inclinación determinan tu rendimiento — hasta ±30% de diferencia.",
  s6_t: "Situación fiscal", s6_s: "Determina tus subvenciones.",
  s6_w: "Los residentes en España reciben hasta 60% de deducción IRPF. Gran impacto en ROI.",
  drag: "Suelta tu factura eléctrica aquí", or_click: "O haz clic para elegir",
  file_too_big: "Archivo demasiado grande (máx 10MB)",
  phase_mono_l: "Monofásico", phase_mono_s: "La mayoría de viviendas — hasta ±9 kW de potencia",
  phase_tri_l: "Trifásico", phase_tri_s: "A menudo villas, ≥ 9,2 kW de potencia contratada",
  phase_unk_l: "No lo sé", phase_unk_s: "Lo deducimos de tu factura eléctrica",
  dw_year_label: "Año de construcción",
  yb1: "Antes de 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "Después de 2018",
  dw_m2_label: "Superficie (m²)", dw_persons_label: "Habitantes", dw_bath_label: "Baños",
  dw_primary_label: "¿Vivienda principal?", yes: "Sí", no: "No",
  dw_type_label: "Tipo de vivienda",
  dwt_detached: "Unifamiliar", dwt_semi: "Pareada", dwt_terrace: "Adosada",
  dwt_apt: "Apartamento", dwt_villa: "Villa",
  usage_q: "¿Cuáles de estos electrodomésticos **vas a comprar** en los próximos años?",
  usage_hint: "Los electrodomésticos que ya tienes están en tu factura actual — no hace falta marcarlos aquí.",
  u_ev: "Coche eléctrico", u_hp: "Bomba de calor", u_pool: "Piscina", u_ac: "Aire acondicionado", u_ind: "Vitro inducción",
  wp_q: "¿Para qué usas tu bomba de calor?",
  wp_water_l: "ACS (ducha, grifo)", wp_water_d: "Aerotermia para agua caliente",
  wp_heating_l: "Calefacción (suelo/radiador)", wp_heating_d: "Aerotermia para toda la vivienda",
  pool_q: "Cuéntanos sobre tu piscina",
  pool_vol_l: "Volumen de la piscina", pool_vol_aux: "≈ {m2} m² × 2 m de profundidad",
  pool_small: "Pequeña (~20)", pool_std: "Estándar (~40)", pool_large: "Grande (~80)",
  pool_cover_q: "¿Tienes cobertor?", pool_cover_yes: "Sí, cubierta", pool_cover_no: "No",
  pool_cover_hint: "Un cobertor ahorra 50-70% de energía de climatización.",
  pool_heat_q: "¿Quieres climatizar la piscina?",
  pool_heat_yes: "Sí, climatizar", pool_heat_no: "No, sin climatizar",
  pool_heat_hint: "Piscina climatizada = +3.000 a 8.000 kWh/año — gran impacto en el tamaño del sistema.",
  pool_heat_type_q: "¿Qué tipo de climatización tienes en mente?",
  pht_aero_l: "Bomba de calor", pht_aero_d: "Aerotermia, la más eficiente",
  pht_solar_l: "Colectores solares", pht_solar_d: "Barato pero depende del clima",
  pht_unk_l: "Sin preferencia", pht_unk_d: "Te asesoramos en tu informe",
  roof_pre_title: "Marca 3+ puntos en tu tejado",
  roof_pre_body: "Busca tu dirección, haz zoom hasta ver tu tejado, y marca las esquinas de la zona apta para paneles.",
  roof_pitch_l: "Inclinación",
  roof_pitch_flat: "5° plano", roof_pitch_mid: "25°", roof_pitch_steep: "45° empinado",
  roof_pitch_auto: "auto",
  roof_pitch_auto_on: "✓ Hemos elegido 25° (tejado promedio)",
  roof_pitch_auto_off: "No lo sé — detectar automáticamente",
  roof_orient_l: "Orientación",
  roof_orient_hint: "Sur = mejor rendimiento en España",
  roof_orient_auto_with_val: "✓ Auto: {val} (según tu tejado)",
  roof_orient_auto_pre: "✓ Lo detectamos desde tu polígono",
  roof_orient_auto_off: "No lo sé — detectar desde mi tejado",
  roof_ok: "Tejado dibujado con {n} esquinas — se guarda al enviar.",
  orientations: { Norte: "Norte", Noreste: "Noreste", Este: "Este", Sureste: "Sureste", Sur: "Sur", Suroeste: "Suroeste", Oeste: "Oeste", Noroeste: "Noroeste" },
  fis_res_q: "¿Eres residente fiscal en España?",
  fis_res_yes: "Sí, vivo en España", fis_res_no: "No, no residente",
  fis_inc_q: "¿Cuál es tu ingreso anual bruto?",
  fis_inc_hint: "Calcularemos tu deducción IRPF. No hace falta el tramo exacto — una estimación basta.",
  ib1: "< € 20.000", ib2: "€ 20.000 – 35.000", ib3: "€ 35.000 – 60.000",
  ib4: "€ 60.000 – 120.000", ib5: "> € 120.000", ib6: "No lo sé",
  ih_bracket: "Tramo {pct}%", ih_unknown: "Usaremos 24% (tramo medio)",
  fis_non_res_title: "Los no residentes pagan 24% de IRPF sobre rentas españolas.",
  fis_non_res_body: "No tienes derecho a deducción IRPF en solar, pero sí a bonificación IBI y fondos UE. Los incluimos en tu informe.",
  final_badge: "Listo — último paso", final_t: "¿Dónde te enviamos\ntu informe?",
  final_p: "Te enviamos el informe completo en 24h. Sin spam, nunca.",
  ct_name_l: "Nombre", ct_name_ph: "Juan García",
  ct_email_l: "Email", ct_email_ph: "juan@email.es",
  ct_wa_l: "WhatsApp (opcional)", ct_wa_ph: "+34 ...",
  submit: "Enviar mi solicitud", submit_busy: "Enviando…",
  summer_footer: "Summer Sale · gratis para los primeros 100",
  footer_text: "100% independiente · Sin ventas · Sin compromiso",
  fill_required: "Por favor completa nombre e email", err_generic: "Algo falló — inténtalo de nuevo",
  toast_ok: "¡Genial! Estás entre los primeros 100 — tu informe es gratis.",
};

const DE = {
  badge: "Summer Sale · 6 Fragen · 100% kostenlos",
  hero_t: "Erzählen Sie uns\nvon Ihrem Haus.",
  hero_p: "Je mehr wir wissen, desto persönlicher Ihr Bericht. Kein Verkaufsgespräch — Ihre Antworten dienen nur Ihrem Dossier.",
  q: "Frage", of_: "von", section_label: "Abschnitt", almost: "Fast fertig",
  vraag_total: "Frage {n} von {total}",
  nav_close_title: "Abschließen",
  s1_t: "Beginnen Sie mit Ihrer Stromrechnung", s1_s: "Eine Datei. Wir machen den Rest.",
  s1_w: "Unsere KI liest Jahresverbrauch, Tarif und Adresse automatisch aus.",
  s2_t: "Anschlussart", s2_s: "Ein-Klick-Bestätigung — wählen Sie Ihre Antwort.",
  s2_w: "Bestimmt, ob wir einen 1-Phasen- oder 3-Phasen-Wechselrichter und Batterie wählen.",
  s3_t: "Zu Ihrem Haus", s3_s: "Baujahr, Fläche, Bewohner.",
  s3_w: "Baujahr und Fläche beeinflussen Förderungen und Systemwahl.",
  s4_t: "Künftige Geräte", s4_s: "Was möchten Sie noch anschaffen?",
  s4_w: "Geräte, die Sie schon haben, sind in Ihrer Rechnung — damit rechnen wir. Hier: was kommt noch dazu.",
  s5_t: "Ihr Dach", s5_s: "Zeichnen Sie Ihr Dach auf dem Satellitenbild.",
  s5_w: "Fläche, Ausrichtung und Neigung bestimmen den Ertrag — bis zu ±30% Unterschied.",
  s6_t: "Steuersituation", s6_s: "Bestimmt Ihre Förderungen.",
  s6_w: "Spanische Residenten erhalten bis zu 60% IRPF-Abzug. Großer ROI-Einfluss.",
  drag: "Stromrechnung hierher ziehen", or_click: "Oder klicken zum Auswählen",
  file_too_big: "Datei zu groß (max. 10MB)",
  phase_mono_l: "1-Phasig (mono)", phase_mono_s: "Die meisten Häuser — bis ±9 kW Anschlussleistung",
  phase_tri_l: "3-Phasig (trifásico)", phase_tri_s: "Oft Villen, ≥ 9,2 kW Anschlussleistung",
  phase_unk_l: "Weiß ich nicht", phase_unk_s: "Wir leiten es aus Ihrer Stromrechnung ab",
  dw_year_label: "Baujahr",
  yb1: "Vor 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "Nach 2018",
  dw_m2_label: "Fläche (m²)", dw_persons_label: "Bewohner", dw_bath_label: "Badezimmer",
  dw_primary_label: "Hauptwohnsitz?", yes: "Ja", no: "Nein",
  dw_type_label: "Haustyp",
  dwt_detached: "Einfamilienhaus", dwt_semi: "Doppelhaus", dwt_terrace: "Reihenhaus",
  dwt_apt: "Wohnung", dwt_villa: "Villa",
  usage_q: "Welche dieser Geräte werden Sie in den kommenden Jahren noch **anschaffen**?",
  usage_hint: "Geräte, die Sie schon besitzen, sind in Ihrer aktuellen Rechnung — die müssen Sie hier nicht ankreuzen.",
  u_ev: "Elektroauto", u_hp: "Wärmepumpe", u_pool: "Pool", u_ac: "Klimaanlage", u_ind: "Induktionskochfeld",
  wp_q: "Wofür nutzen Sie Ihre Wärmepumpe?",
  wp_water_l: "Warmwasser (Dusche, Hahn)", wp_water_d: "Aerothermie für Warmwasser",
  wp_heating_l: "Heizung (Boden/Heizkörper)", wp_heating_d: "Aerothermie für das ganze Haus",
  pool_q: "Erzählen Sie uns von Ihrem Pool",
  pool_vol_l: "Poolvolumen", pool_vol_aux: "≈ {m2} m² × 2 m tief",
  pool_small: "Klein (~20)", pool_std: "Standard (~40)", pool_large: "Groß (~80)",
  pool_cover_q: "Haben Sie eine Abdeckung?", pool_cover_yes: "Ja, abgedeckt", pool_cover_no: "Nein",
  pool_cover_hint: "Eine Abdeckung spart 50-70% Heizenergie.",
  pool_heat_q: "Möchten Sie den Pool beheizen?",
  pool_heat_yes: "Ja, beheizen", pool_heat_no: "Nein, unbeheizt",
  pool_heat_hint: "Beheizter Pool = +3.000 bis 8.000 kWh/Jahr — großer Einfluss auf die Systemgröße.",
  pool_heat_type_q: "Welche Heizart haben Sie im Sinn?",
  pht_aero_l: "Wärmepumpe", pht_aero_d: "Aerothermie, am effizientesten",
  pht_solar_l: "Solarkollektoren", pht_solar_d: "Günstig, aber wetterabhängig",
  pht_unk_l: "Keine Präferenz", pht_unk_d: "Wir beraten Sie im Bericht",
  roof_pre_title: "Klicken Sie 3+ Punkte auf Ihr Dach",
  roof_pre_body: "Suchen Sie Ihre Adresse, zoomen Sie auf Ihr Dach und klicken Sie die Ecken der für Module geeigneten Dachfläche.",
  roof_pitch_l: "Neigungswinkel",
  roof_pitch_flat: "5° flach", roof_pitch_mid: "25°", roof_pitch_steep: "45° steil",
  roof_pitch_auto: "auto",
  roof_pitch_auto_on: "✓ Wir haben 25° gewählt (Durchschnittsdach)",
  roof_pitch_auto_off: "Weiß ich nicht — automatisch bestimmen",
  roof_orient_l: "Ausrichtung",
  roof_orient_hint: "Süden = bester Ertrag in Spanien",
  roof_orient_auto_with_val: "✓ Auto: {val} (basierend auf Ihrem Dach)",
  roof_orient_auto_pre: "✓ Wir bestimmen es aus Ihrem Polygon",
  roof_orient_auto_off: "Weiß ich nicht — aus meinem Dach bestimmen",
  roof_ok: "Dach mit {n} Eckpunkten gezeichnet — beim Senden gespeichert.",
  orientations: { Norte: "Nord", Noreste: "Nordost", Este: "Ost", Sureste: "Südost", Sur: "Süd", Suroeste: "Südwest", Oeste: "West", Noroeste: "Nordwest" },
  fis_res_q: "Sind Sie Steuerresident in Spanien?",
  fis_res_yes: "Ja, ich wohne in Spanien", fis_res_no: "Nein, nicht-resident",
  fis_inc_q: "Wie hoch ist Ihr Bruttojahreseinkommen?",
  fis_inc_hint: "Wir berechnen Ihren IRPF-Abzug. Keine exakte Stufe nötig — eine Schätzung genügt.",
  ib1: "< € 20.000", ib2: "€ 20.000 – 35.000", ib3: "€ 35.000 – 60.000",
  ib4: "€ 60.000 – 120.000", ib5: "> € 120.000", ib6: "Weiß ich nicht",
  ih_bracket: "Stufe {pct}%", ih_unknown: "Wir rechnen mit 24% (mittlere Stufe)",
  fis_non_res_title: "Nicht-Residenten zahlen 24% IRPF auf spanische Einkünfte.",
  fis_non_res_body: "Sie haben keinen Anspruch auf IRPF-Abzug bei Solar, aber auf IBI-Bonus und EU-Förderungen. Die berücksichtigen wir im Bericht.",
  final_badge: "Fertig — letzter Schritt", final_t: "Wohin senden wir\nIhren Bericht?",
  final_p: "Wir senden den vollständigen Bericht innerhalb von 24h. Kein Spam, nie.",
  ct_name_l: "Name", ct_name_ph: "Max Müller",
  ct_email_l: "E-Mail", ct_email_ph: "max@email.es",
  ct_wa_l: "WhatsApp (optional)", ct_wa_ph: "+34 ...",
  submit: "Bericht anfordern", submit_busy: "Wird gesendet…",
  summer_footer: "Summer Sale · gratis für die ersten 100",
  footer_text: "100% unabhängig · Kein Verkauf · Unverbindlich",
  fill_required: "Bitte Name und E-Mail ausfüllen", err_generic: "Etwas ging schief — bitte erneut versuchen",
  toast_ok: "Großartig! Sie gehören zu den ersten 100 — Ihr Bericht ist kostenlos!",
};

const FR = {
  badge: "Summer Sale · 6 questions · 100% gratuit",
  hero_t: "Parlez-nous de\nvotre logement.",
  hero_p: "Plus on en sait, plus votre rapport est personnel. Pas de vente — vos réponses servent uniquement à votre dossier.",
  q: "Question", of_: "sur", section_label: "Section", almost: "Presque fini",
  vraag_total: "Question {n} sur {total}",
  nav_close_title: "Terminer",
  s1_t: "Commencez par votre facture d'électricité", s1_s: "Un fichier. On fait le reste.",
  s1_w: "Notre IA extrait votre consommation annuelle, tarif et adresse automatiquement.",
  s2_t: "Type de raccordement", s2_s: "Confirmation en un clic.",
  s2_w: "Détermine si on choisit un onduleur & batterie monophasé ou triphasé.",
  s3_t: "Votre logement", s3_s: "Année, surface, occupants.",
  s3_w: "Année et surface influencent les subventions et le choix optimal.",
  s4_t: "Appareils futurs", s4_s: "Que comptez-vous encore acheter ?",
  s4_w: "Vos appareils actuels figurent dans votre facture — on les prend déjà en compte. Ici, dites-nous ce qui s'ajoute.",
  s5_t: "Votre toit", s5_s: "Dessinez votre toit sur l'image satellite.",
  s5_w: "Surface, orientation et inclinaison déterminent le rendement — jusqu'à ±30%.",
  s6_t: "Situation fiscale", s6_s: "Détermine vos subventions.",
  s6_w: "Les résidents espagnols obtiennent jusqu'à 60% de déduction IRPF. Gros impact sur le ROI.",
  drag: "Déposez votre facture ici", or_click: "Ou cliquez pour choisir",
  file_too_big: "Fichier trop volumineux (max 10 Mo)",
  phase_mono_l: "Monophasé", phase_mono_s: "La plupart des logements — jusqu'à ±9 kW",
  phase_tri_l: "Triphasé", phase_tri_s: "Souvent villas, ≥ 9,2 kW",
  phase_unk_l: "Je ne sais pas", phase_unk_s: "On le déduit de votre facture",
  dw_year_label: "Année de construction",
  yb1: "Avant 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "Après 2018",
  dw_m2_label: "Surface (m²)", dw_persons_label: "Occupants", dw_bath_label: "Salles de bain",
  dw_primary_label: "Résidence principale ?", yes: "Oui", no: "Non",
  dw_type_label: "Type de logement",
  dwt_detached: "Maison individuelle", dwt_semi: "Jumelée", dwt_terrace: "Mitoyenne",
  dwt_apt: "Appartement", dwt_villa: "Villa",
  usage_q: "Lesquels de ces appareils **allez-vous encore acheter** dans les prochaines années ?",
  usage_hint: "Les appareils déjà chez vous sont dans votre facture actuelle — pas besoin de les cocher.",
  u_ev: "Voiture électrique", u_hp: "Pompe à chaleur", u_pool: "Piscine", u_ac: "Climatisation", u_ind: "Plaque à induction",
  wp_q: "Pour quoi utilisez-vous votre pompe à chaleur ?",
  wp_water_l: "Eau chaude (douche, robinet)", wp_water_d: "Aérothermie pour eau chaude",
  wp_heating_l: "Chauffage (sol/radiateur)", wp_heating_d: "Aérothermie pour tout le logement",
  pool_q: "Parlez-nous de votre piscine",
  pool_vol_l: "Volume de la piscine", pool_vol_aux: "≈ {m2} m² × 2 m de profondeur",
  pool_small: "Petite (~20)", pool_std: "Standard (~40)", pool_large: "Grande (~80)",
  pool_cover_q: "Avez-vous une bâche ?", pool_cover_yes: "Oui, couverte", pool_cover_no: "Non",
  pool_cover_hint: "Une bâche économise 50-70% d'énergie de chauffage.",
  pool_heat_q: "Voulez-vous chauffer la piscine ?",
  pool_heat_yes: "Oui, chauffée", pool_heat_no: "Non, non chauffée",
  pool_heat_hint: "Piscine chauffée = +3 000 à 8 000 kWh/an — gros impact sur la taille du système.",
  pool_heat_type_q: "Quel type de chauffage envisagez-vous ?",
  pht_aero_l: "Pompe à chaleur", pht_aero_d: "Aérothermie, la plus efficace",
  pht_solar_l: "Capteurs solaires", pht_solar_d: "Bon marché mais dépend du climat",
  pht_unk_l: "Sans préférence", pht_unk_d: "On vous conseille dans le rapport",
  roof_pre_title: "Cliquez 3+ points sur votre toit",
  roof_pre_body: "Cherchez votre adresse, zoomez sur votre toit, et cliquez les coins de la zone propice aux panneaux.",
  roof_pitch_l: "Inclinaison",
  roof_pitch_flat: "5° plat", roof_pitch_mid: "25°", roof_pitch_steep: "45° pentu",
  roof_pitch_auto: "auto",
  roof_pitch_auto_on: "✓ Nous avons choisi 25° (toit moyen)",
  roof_pitch_auto_off: "Je ne sais pas — détection automatique",
  roof_orient_l: "Orientation",
  roof_orient_hint: "Sud = meilleur rendement en Espagne",
  roof_orient_auto_with_val: "✓ Auto : {val} (d'après votre toit)",
  roof_orient_auto_pre: "✓ On le détecte depuis votre polygone",
  roof_orient_auto_off: "Je ne sais pas — détecter depuis mon toit",
  roof_ok: "Toit dessiné avec {n} coins — enregistré à l'envoi.",
  orientations: { Norte: "Nord", Noreste: "Nord-Est", Este: "Est", Sureste: "Sud-Est", Sur: "Sud", Suroeste: "Sud-Ouest", Oeste: "Ouest", Noroeste: "Nord-Ouest" },
  fis_res_q: "Êtes-vous résident fiscal en Espagne ?",
  fis_res_yes: "Oui, je vis en Espagne", fis_res_no: "Non, non-résident",
  fis_inc_q: "Quel est votre revenu annuel brut ?",
  fis_inc_hint: "Nous calculons votre déduction IRPF. Pas besoin de la tranche exacte — une estimation suffit.",
  ib1: "< 20 000 €", ib2: "20 000 – 35 000 €", ib3: "35 000 – 60 000 €",
  ib4: "60 000 – 120 000 €", ib5: "> 120 000 €", ib6: "Je ne sais pas",
  ih_bracket: "Tranche {pct}%", ih_unknown: "Nous prenons 24% (tranche médiane)",
  fis_non_res_title: "Les non-résidents payent 24% d'IRPF sur leurs revenus espagnols.",
  fis_non_res_body: "Pas de déduction IRPF sur le solaire, mais bonus IBI et fonds UE oui. Nous les incluons dans votre rapport.",
  final_badge: "Prêt — dernière étape", final_t: "Où vous envoyons-nous\nvotre rapport ?",
  final_p: "On envoie le rapport complet sous 24h. Pas de spam, jamais.",
  ct_name_l: "Nom", ct_name_ph: "Jean Dupont",
  ct_email_l: "E-mail", ct_email_ph: "jean@email.es",
  ct_wa_l: "WhatsApp (optionnel)", ct_wa_ph: "+34 ...",
  submit: "Envoyer ma demande", submit_busy: "Envoi…",
  summer_footer: "Summer Sale · gratuit pour les 100 premiers",
  footer_text: "100% indépendant · Sans vente · Sans engagement",
  fill_required: "Veuillez remplir nom et e-mail", err_generic: "Une erreur — réessayez",
  toast_ok: "Bravo ! Vous faites partie des 100 premiers — rapport gratuit !",
};

const DA = {
  badge: "Summer Sale · 6 spørgsmål · 100% gratis",
  hero_t: "Fortæl os om\ndin bolig.",
  hero_p: "Jo mere vi ved, jo mere personlig din rapport. Intet salgssnak — dine svar bruges kun til dit dossier.",
  q: "Spørgsmål", of_: "af", section_label: "Afsnit", almost: "Næsten færdig",
  vraag_total: "Spørgsmål {n} af {total}",
  nav_close_title: "Afslut",
  s1_t: "Start med din elregning", s1_s: "Én fil. Vi klarer resten.",
  s1_w: "Vores AI læser dit årsforbrug, tarif og adresse automatisk.",
  s2_t: "Din tilslutningstype", s2_s: "Ét-klik bekræftelse.",
  s2_w: "Bestemmer om vi vælger 1-faset eller 3-faset inverter og batteri.",
  s3_t: "Om din bolig", s3_s: "Byggeår, areal, beboere.",
  s3_w: "Byggeår og areal påvirker tilskud og optimalt systemvalg.",
  s4_t: "Fremtidige apparater", s4_s: "Hvad planlægger du at købe?",
  s4_w: "Det du allerede har er i din elregning — det medregner vi. Her: hvad du tilføjer.",
  s5_t: "Dit tag", s5_s: "Tegn dit tag på satellitbilledet.",
  s5_w: "Areal, orientering og hældning bestemmer dit udbytte — op til ±30%.",
  s6_t: "Skatteforhold", s6_s: "Bestemmer dine tilskud.",
  s6_w: "Spanske residenter får op til 60% IRPF-fradrag. Stor ROI-effekt.",
  drag: "Drop din elregning her", or_click: "Eller klik for at vælge",
  file_too_big: "Fil for stor (maks 10MB)",
  phase_mono_l: "1-faset (mono)", phase_mono_s: "De fleste boliger — op til ±9 kW",
  phase_tri_l: "3-faset (trifásico)", phase_tri_s: "Ofte villaer, ≥ 9,2 kW",
  phase_unk_l: "Ved ikke", phase_unk_s: "Vi udleder det fra din elregning",
  dw_year_label: "Byggeår",
  yb1: "Før 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "Efter 2018",
  dw_m2_label: "Areal (m²)", dw_persons_label: "Beboere", dw_bath_label: "Badeværelser",
  dw_primary_label: "Helårsbolig?", yes: "Ja", no: "Nej",
  dw_type_label: "Boligtype",
  dwt_detached: "Fritliggende", dwt_semi: "Dobbelthus", dwt_terrace: "Rækkehus",
  dwt_apt: "Lejlighed", dwt_villa: "Villa",
  usage_q: "Hvilke af disse apparater **vil du stadig købe** i de kommende år?",
  usage_hint: "Apparater du allerede ejer er i din nuværende regning — du behøver ikke krydse dem af her.",
  u_ev: "Elbil", u_hp: "Varmepumpe", u_pool: "Pool", u_ac: "Aircondition", u_ind: "Induktionskogeplade",
  wp_q: "Hvad bruger du din varmepumpe til?",
  wp_water_l: "Varmt vand (brus, hane)", wp_water_d: "Aerotermi til varmt vand",
  wp_heating_l: "Opvarmning (gulv/radiator)", wp_heating_d: "Aerotermi til hele boligen",
  pool_q: "Fortæl os om din pool",
  pool_vol_l: "Poolvolumen", pool_vol_aux: "≈ {m2} m² × 2 m dyb",
  pool_small: "Lille (~20)", pool_std: "Standard (~40)", pool_large: "Stor (~80)",
  pool_cover_q: "Har du et dække?", pool_cover_yes: "Ja, tildækket", pool_cover_no: "Nej",
  pool_cover_hint: "Et dække sparer 50-70% varmeenergi.",
  pool_heat_q: "Vil du opvarme poolen?",
  pool_heat_yes: "Ja, opvarmet", pool_heat_no: "Nej, uopvarmet",
  pool_heat_hint: "Opvarmet pool = +3.000 til 8.000 kWh/år — stor effekt på systemstørrelsen.",
  pool_heat_type_q: "Hvilken opvarmningstype tænker du på?",
  pht_aero_l: "Varmepumpe", pht_aero_d: "Aerotermi, mest effektiv",
  pht_solar_l: "Solfangere", pht_solar_d: "Billigt men vejrafhængigt",
  pht_unk_l: "Ingen præference", pht_unk_d: "Vi rådgiver dig i rapporten",
  roof_pre_title: "Klik 3+ punkter på dit tag",
  roof_pre_body: "Søg din adresse, zoom ind på dit tag, og klik hjørnerne af tagfladen egnet til paneler.",
  roof_pitch_l: "Hældningsvinkel",
  roof_pitch_flat: "5° fladt", roof_pitch_mid: "25°", roof_pitch_steep: "45° stejlt",
  roof_pitch_auto: "auto",
  roof_pitch_auto_on: "✓ Vi har valgt 25° (gennemsnitstag)",
  roof_pitch_auto_off: "Ved ikke — registrer automatisk",
  roof_orient_l: "Orientering",
  roof_orient_hint: "Syd = bedste udbytte i Spanien",
  roof_orient_auto_with_val: "✓ Auto: {val} (fra dit tag)",
  roof_orient_auto_pre: "✓ Vi registrerer det fra din polygon",
  roof_orient_auto_off: "Ved ikke — registrer fra mit tag",
  roof_ok: "Tag tegnet med {n} hjørner — gemmes ved indsendelse.",
  orientations: { Norte: "Nord", Noreste: "Nordøst", Este: "Øst", Sureste: "Sydøst", Sur: "Syd", Suroeste: "Sydvest", Oeste: "Vest", Noroeste: "Nordvest" },
  fis_res_q: "Er du skatteresident i Spanien?",
  fis_res_yes: "Ja, jeg bor i Spanien", fis_res_no: "Nej, ikke-resident",
  fis_inc_q: "Hvad er din årlige bruttoindkomst?",
  fis_inc_hint: "Vi beregner dit IRPF-fradrag. Ingen præcis trin nødvendigt — et skøn er fint.",
  ib1: "< 20.000 €", ib2: "20.000 – 35.000 €", ib3: "35.000 – 60.000 €",
  ib4: "60.000 – 120.000 €", ib5: "> 120.000 €", ib6: "Ved ikke",
  ih_bracket: "Trin {pct}%", ih_unknown: "Vi bruger 24% (mellemtrin)",
  fis_non_res_title: "Ikke-residenter betaler 24% IRPF på spanske indkomster.",
  fis_non_res_body: "Du har ikke ret til IRPF-fradrag på solar, men IBI-bonus og EU-fonde ja. Dem inkluderer vi i rapporten.",
  final_badge: "Klar — sidste trin", final_t: "Hvor skal vi sende\ndin rapport?",
  final_p: "Vi mailer hele rapporten inden for 24t. Aldrig spam.",
  ct_name_l: "Navn", ct_name_ph: "Lars Hansen",
  ct_email_l: "E-mail", ct_email_ph: "lars@email.es",
  ct_wa_l: "WhatsApp (valgfrit)", ct_wa_ph: "+34 ...",
  submit: "Send min anmodning", submit_busy: "Sender…",
  summer_footer: "Summer Sale · gratis for de første 100",
  footer_text: "100% uafhængig · Intet salg · Uforpligtende",
  fill_required: "Udfyld navn og e-mail", err_generic: "Noget gik galt — prøv igen",
  toast_ok: "Fantastisk! Du er blandt de første 100 — din rapport er gratis!",
};

const RU = {
  badge: "Summer Sale · 6 вопросов · 100% бесплатно",
  hero_t: "Расскажите о\nсвоём доме.",
  hero_p: "Чем больше мы знаем, тем персональнее ваш отчёт. Без продаж — ответы используем только для вашего досье.",
  q: "Вопрос", of_: "из", section_label: "Раздел", almost: "Почти готово",
  vraag_total: "Вопрос {n} из {total}",
  nav_close_title: "Завершить",
  s1_t: "Начните со счёта за электричество", s1_s: "Один файл. Остальное мы.",
  s1_w: "Наш ИИ извлечёт годовое потребление, тариф и адрес автоматически.",
  s2_t: "Тип подключения", s2_s: "Подтверждение в один клик.",
  s2_w: "Определяет однофазный или трёхфазный инвертор и батарею.",
  s3_t: "О вашем доме", s3_s: "Год, площадь, жильцы.",
  s3_w: "Год и площадь влияют на субсидии и выбор системы.",
  s4_t: "Будущая техника", s4_s: "Что планируете купить?",
  s4_w: "Что у вас уже есть — в текущем счёте. Здесь: что добавите.",
  s5_t: "Ваша крыша", s5_s: "Нарисуйте крышу на спутниковом снимке.",
  s5_w: "Площадь, ориентация и наклон определяют выработку — до ±30%.",
  s6_t: "Налоговая ситуация", s6_s: "Определяет ваши субсидии.",
  s6_w: "Резиденты Испании получают до 60% вычет IRPF. Большое влияние на ROI.",
  drag: "Перетащите счёт сюда", or_click: "Или нажмите для выбора",
  file_too_big: "Файл слишком большой (макс 10МБ)",
  phase_mono_l: "Однофазный (моно)", phase_mono_s: "Большинство домов — до ±9 кВт мощности",
  phase_tri_l: "Трёхфазный (trifásico)", phase_tri_s: "Часто виллы, ≥ 9,2 кВт мощности",
  phase_unk_l: "Не знаю", phase_unk_s: "Мы определим по вашему счёту",
  dw_year_label: "Год постройки",
  yb1: "До 1980", yb2: "1980 – 1995", yb3: "1995 – 2007", yb4: "2007 – 2018", yb5: "После 2018",
  dw_m2_label: "Площадь (м²)", dw_persons_label: "Жильцы", dw_bath_label: "Ванные",
  dw_primary_label: "Основное жильё?", yes: "Да", no: "Нет",
  dw_type_label: "Тип жилья",
  dwt_detached: "Отдельный дом", dwt_semi: "Сдвоенный", dwt_terrace: "Таунхаус",
  dwt_apt: "Квартира", dwt_villa: "Вилла",
  usage_q: "Какие из этих приборов вы **ещё планируете купить** в ближайшие годы?",
  usage_hint: "Приборы, которые у вас уже есть, в текущем счёте — здесь их отмечать не нужно.",
  u_ev: "Электромобиль", u_hp: "Тепловой насос", u_pool: "Бассейн", u_ac: "Кондиционер", u_ind: "Индукционная плита",
  wp_q: "Для чего используете тепловой насос?",
  wp_water_l: "Горячая вода (душ, кран)", wp_water_d: "Аэротермия для горячей воды",
  wp_heating_l: "Отопление (пол/радиатор)", wp_heating_d: "Аэротермия для всего дома",
  pool_q: "Расскажите о вашем бассейне",
  pool_vol_l: "Объём бассейна", pool_vol_aux: "≈ {m2} м² × 2 м глубина",
  pool_small: "Малый (~20)", pool_std: "Стандарт (~40)", pool_large: "Большой (~80)",
  pool_cover_q: "Есть ли покрытие?", pool_cover_yes: "Да, закрыт", pool_cover_no: "Нет",
  pool_cover_hint: "Покрытие экономит 50-70% энергии нагрева.",
  pool_heat_q: "Хотите ли подогрев бассейна?",
  pool_heat_yes: "Да, с подогревом", pool_heat_no: "Нет, без подогрева",
  pool_heat_hint: "Подогретый бассейн = +3 000 до 8 000 кВт·ч/год — большое влияние на размер системы.",
  pool_heat_type_q: "Какой тип нагрева вы рассматриваете?",
  pht_aero_l: "Тепловой насос", pht_aero_d: "Аэротермия, самый эффективный",
  pht_solar_l: "Солнечные коллекторы", pht_solar_d: "Дёшево, но зависит от погоды",
  pht_unk_l: "Без предпочтений", pht_unk_d: "Посоветуем в отчёте",
  roof_pre_title: "Кликните 3+ точки на крыше",
  roof_pre_body: "Найдите адрес на карте, увеличьте до крыши и кликните углы участка, подходящего для панелей.",
  roof_pitch_l: "Угол наклона",
  roof_pitch_flat: "5° плоский", roof_pitch_mid: "25°", roof_pitch_steep: "45° крутой",
  roof_pitch_auto: "авто",
  roof_pitch_auto_on: "✓ Мы выбрали 25° (средняя крыша)",
  roof_pitch_auto_off: "Не знаю — определить автоматически",
  roof_orient_l: "Ориентация",
  roof_orient_hint: "Юг = лучшая выработка в Испании",
  roof_orient_auto_with_val: "✓ Авто: {val} (по форме крыши)",
  roof_orient_auto_pre: "✓ Определим из вашего полигона",
  roof_orient_auto_off: "Не знаю — определить по моей крыше",
  roof_ok: "Крыша нарисована с {n} углами — сохраняется при отправке.",
  orientations: { Norte: "Север", Noreste: "Северо-восток", Este: "Восток", Sureste: "Юго-восток", Sur: "Юг", Suroeste: "Юго-запад", Oeste: "Запад", Noroeste: "Северо-запад" },
  fis_res_q: "Вы налоговый резидент Испании?",
  fis_res_yes: "Да, я живу в Испании", fis_res_no: "Нет, не резидент",
  fis_inc_q: "Каков ваш годовой доход до налогов?",
  fis_inc_hint: "Рассчитаем ваш вычет IRPF. Точная ступень не нужна — оценки достаточно.",
  ib1: "< 20 000 €", ib2: "20 000 – 35 000 €", ib3: "35 000 – 60 000 €",
  ib4: "60 000 – 120 000 €", ib5: "> 120 000 €", ib6: "Не знаю",
  ih_bracket: "Ступень {pct}%", ih_unknown: "Используем 24% (средняя ступень)",
  fis_non_res_title: "Нерезиденты платят 24% IRPF с испанских доходов.",
  fis_non_res_body: "Вычета IRPF на солнечные нет, но скидка IBI и фонды ЕС — да. Включаем в отчёт.",
  final_badge: "Готово — последний шаг", final_t: "Куда отправить\nваш отчёт?",
  final_p: "Отправим полный отчёт в течение 24ч. Без спама, никогда.",
  ct_name_l: "Имя", ct_name_ph: "Иван Петров",
  ct_email_l: "Email", ct_email_ph: "ivan@email.es",
  ct_wa_l: "WhatsApp (необязательно)", ct_wa_ph: "+34 ...",
  submit: "Отправить запрос", submit_busy: "Отправка…",
  summer_footer: "Summer Sale · бесплатно первым 100",
  footer_text: "100% независимо · Без продаж · Без обязательств",
  fill_required: "Заполните имя и email", err_generic: "Что-то пошло не так — попробуйте снова",
  toast_ok: "Отлично! Вы среди первых 100 — отчёт бесплатно!",
};

export const INTAKE_I18N = { nl: NL, en: EN, es: ES, de: DE, fr: FR, da: DA, ru: RU };

export const getIntakeT = (lang) => {
  const code = (lang || "es").split("-")[0].toLowerCase();
  return INTAKE_I18N[code] || INTAKE_I18N.es;
};

// Tiny formatter — replaces {key} tokens in a string with values from vars.
export const fmt = (str, vars = {}) =>
  String(str || "").replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
